import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { isChunkLoadError } from '~/lib/lazyWithRetry'
import styles from './styles.module.css'

type Props = {
  error: unknown
}

/**
 * インスタンス画面専用のエラーフォールバック。
 *
 * アプリ最上位の ErrorBoundary より手前でインスタンス内のレンダリング例外を捕捉し、
 * 全画面クラッシュ（＝インスタンスから追い出される）のを防ぐ。Sentryへの報告は
 * ErrorBoundary 側で維持される。
 */
export function InstanceErrorFallback({ error }: Props) {
  const navigate = useNavigate()
  const chunkError = isChunkLoadError(error)

  const handleReload = useCallback(() => {
    window.location.reload()
  }, [])

  const handleGoHome = useCallback(() => {
    navigate('/')
  }, [navigate])

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        {chunkError ? (
          <>
            <h2 className={styles.title}>アプリが更新されました</h2>
            <p className={styles.message}>
              新しいバージョンが公開されています。再読み込みしてください。
            </p>
          </>
        ) : (
          <>
            <h2 className={styles.title}>表示に問題が発生しました</h2>
            <p className={styles.message}>
              インスタンスの表示中にエラーが発生しました。再読み込みするか、ホームに戻ってください。
            </p>
          </>
        )}
        <div className={styles.actions}>
          <button type="button" className={styles.reloadButton} onClick={handleReload}>
            再読み込み
          </button>
          <button type="button" className={styles.homeButton} onClick={handleGoHome}>
            ホームに戻る
          </button>
        </div>
      </div>
    </div>
  )
}
